import React from "react";
import SalesPagesContainer from "../../modules/GASalesPages/containers/SalesPagesContainer/SalesPagesContainer";

const GASalesPages = () => {
  return <SalesPagesContainer />;
};

export default GASalesPages;
